var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docView"},[_c('div',{ref:"docHtml",staticClass:"docHtml",domProps:{"innerHTML":_vm._s(_vm.html)},on:{"click":_vm.selectDiv}})])
}
var staticRenderFns = []

export { render, staticRenderFns }